import { ReactNode } from "react";
import clsx from "clsx";
import { cn } from "@/core/helpers/cn";

type Props = {
  logoSrc: string;
  title: string;
  description: string;
  className?: string;
  dataMzAccent?: string;
  isBackground?: boolean;
  children: ReactNode;
};
export default function DeviceTabsWrapper({
  logoSrc,
  title,
  description,
  className,
  dataMzAccent,
  isBackground,
  children,
}: Props) {
  return (
    <div
      className={cn("flex flex-col gap-1.5 w-[19rem] shrink-0 p-7.5", className)}
      data-mz-accent={dataMzAccent}
    >
      <div className="flex items-center gap-2.5 mb-3">
        <img src={logoSrc} className="w-[2.625rem] h-[2.625rem]" alt="app-logo" />
        <div>
          <p className="text-15 font-bold text-inverted uppercase">{title}</p>
          <div
            className={clsx("text-14 font-medium", isBackground ? "text-gray/80" : "text-gray/50")}
          >
            {description}
          </div>
        </div>
      </div>
      {children}
    </div>
  );
}
